export const extractCalendarDateParts = (value) => {
    if (!value) return null;

    const match = String(value).match(/^(\d{4})-(\d{2})-(\d{2})/);
    if (!match) return null;

    const [, year, month, day] = match;
    return { year, month, day };
}

export const formatPresentationDate = (dateString) => {
    const parts = extractCalendarDateParts(dateString);
    if (!parts) return '';

    return `${parts.month}-${parts.day}-${parts.year}`;
}

export const formatCalendarDateLong = (dateString) => {
    const parts = extractCalendarDateParts(dateString);
    if (!parts) return '';

    const monthLabel = [
        'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
        'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec',
    ][Number(parts.month) - 1];

    if (!monthLabel) return '';
    return `${monthLabel} ${Number(parts.day)}, ${parts.year}`;
}
export function convertAddressToString(address) {
    if (address) {
        const { street, city, state, postal, country } = address;

        const addressParts = [];

        if (street) addressParts.push(street);
        if (city) addressParts.push(city);
        if (state) addressParts.push(state);
        if (postal) addressParts.push(postal);
        if (country) addressParts.push(country);
        return addressParts.join(', ');

    }
    return '';

}
export const formatFullAddress = (address) => {
    console.log(address)
    if (!address) return '';

    const {
        companyName,
        streetAddress,
        suiteApt,
        optional1,
        optional2,
        city,
        stateProvince,
        postalZipCode,
        country
    } = address;

    return [
        companyName,
        streetAddress,
        suiteApt,
        optional1,
        optional2,
        `${city}, ${stateProvince} ${postalZipCode}`,
        country
    ].filter(Boolean).join(', ');
};
